import { createRef, useEffect } from "react";
import type { NextPage } from "next";

import AnalyticsSender from "../helpers/analyticsSender";

import Meta from "../components/meta/index";
import Header from "../components/header";
import Welcome from "../components/welcome";
import Preview from "../components/previews/previews-containers";
import HowTo from "../components/how-to/index";
import Usage from "../components/usage/index";
import Options from "../components/options/index";
import Footer from "../components/footer/footer-container";
import Popup from "../components/popups/popup";
import imageActions from "../redux/actions/imageActions";
import canvasActions from "../redux/actions/canvasActions";
import Service from "../components/service/service-container";

const Resizer: NextPage = (): JSX.Element => {
  const uploadElement = createRef<HTMLButtonElement>();
  const analyticsSender = new AnalyticsSender();
  const serviceName = "flipper";

  const { image, imageWidth, imageHeight, imageName } = imageActions();
  const { canvasImage, canvasWidth, canvasHeight } = canvasActions();

  useEffect(() => {
    analyticsSender.sendShowLandingPage();
  }, []);

  return (
    <>
      <Meta service={serviceName} />
      <main>
        <Header uploadElement={uploadElement} />
        <Welcome service={serviceName}>
          <Service service={serviceName} uploadElement={uploadElement}/>
        </Welcome>
        <Preview
          service={serviceName}
          image={canvasImage}
          imageName={imageName}
          width={imageWidth}
          height={imageHeight}
          uploadElement={uploadElement}
          showDescription={false}
        />
        <Options service={serviceName} />
        <Usage service={serviceName} />
        <HowTo service={serviceName} />
        <Footer />
        <Popup service={serviceName} />
      </main>
    </>
  );
};

export default Resizer;
